module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_trouble06-9604dcba77d63326da60e5b762e699f1.png";